import PropTypes from "prop-types";
import * as React from "react";

import Members from "../../Containers/ContainerMembersRoute";

const propTypes = {
  params: PropTypes.shape({
    clanId: PropTypes.string
  }).isRequired
};

const MembersRoute = props => {
  return <Members clanId={props.params.clanId ? Number(props.params.clanId) : null} />;
};

MembersRoute.propTypes = propTypes;

export default MembersRoute;